<div
  class="row-layout"
  style="align-items: center; justify-content: space-between; max-height: 50vh"
>
  <div *ngIf="data.type === 'error'">
    <div class="snack-error-title">Fehler</div>
    <div class="snack-errors-item" *ngFor="let err of errors">
      {{ err }}
    </div>
  </div>
  <div *ngIf="data.type === 'success'">
    <div class="snack-successs-title">{{ data.msg }}</div>
    <div *ngFor="let msg of messages" class="snack-msg-item">
      {{ msg }}
    </div>
    <div class="snack-errors-item" *ngFor="let err of errors">
      {{ err }}
    </div>
  </div>
  <div *ngIf="data.type === 'question'">
    <div class="snack-successs-title">{{ data.msg }}</div>
    <div *ngFor="let msg of messages" class="snack-msg-item">
      {{ msg }}
    </div>
  </div>
  <div style="padding: 0.25rem 0.5rem 0.25rem 1rem">
    <ng-container *ngFor="let btn of data.buttons">
      <button
      mat-raised-button
      [ngClass]="btn.cls||''"
      style="margin-left: 1rem; margin-bottom: 0.4rem;"

      (click)="answer(btn.value)"
    >
      {{ btn.label }}
    </button>
    </ng-container>


    <button
      mat-button
      [ngClass]="btnClass"
      *ngIf="hasAction && data.type !== 'question'"
      (click)="dismiss()"
    >
      {{ action }}
    </button>
  </div>
</div>
